// auth.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MsalModule,
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG,
  MsalService,
  MsalGuard,
  MsalInterceptor,
} from '@azure/msal-angular';
import { MsalConfigService } from './msal-config.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { PublicAccessGuard } from '../core/guards/public-access.guard';
import { AuthInterceptor } from '../core/interceptor/auth.interceptor';
import { UnauthorizedInterceptor } from '../core/interceptor/unauthorized.interceptor';

@NgModule({
  imports: [CommonModule, MsalModule],
  providers: [
    {
      provide: MSAL_INSTANCE,
      useFactory: MsalConfigService.createMsalInstance,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MsalConfigService.msalGuardConfig,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MsalConfigService.msalInterceptorConfig,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor,
      multi: true,
    },
    MsalService,
    MsalInterceptor,
  ],
})
export class AuthModule { }
